/** Shared attrs so iOS Safari actually keeps typed/autofilled email in sync with React. */
export const mobileEmailInputProps = {
  // type=email on iOS often fails to fire onChange / drops @; use text + email keyboard
  type: "text" as const,
  inputMode: "email" as const,
  autoComplete: "email" as const,
  autoCapitalize: "none" as const,
  autoCorrect: "off" as const,
  spellCheck: false as const,
  name: "email" as const,
};

export const mobilePasswordInputProps = {
  autoComplete: "current-password" as const,
  name: "password" as const,
};

/** Prefer live DOM value (autofill) over React state. */
export function readFormField(
  form: EventTarget | null,
  fieldName: string,
  fallback: string,
): string {
  if (form && "elements" in (form as HTMLFormElement)) {
    const el = (form as HTMLFormElement).elements.namedItem(fieldName);
    if (el && "value" in el && typeof (el as HTMLInputElement).value === "string") {
      return String((el as HTMLInputElement).value);
    }
  }
  return fallback;
}
